import { Serializer } from "miragejs";

export default Serializer.extend({
  root: false,
  embed: true
});
